import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { DeviceDetectorService } from 'ngx-device-detector';
import { ApiService } from '../api.services';
import { longDate, showNotification } from '../../../consts/utils';
import { superAdminHttpRoutes, superAdminHttpVersion } from '../../../consts/super_admin_http_routes';
import { configData } from '../../../../environments/configData';

@Injectable({
    providedIn: 'root'
})

export class SuperAdminUserActivityService {
    lookupInfo: any;
    deviceInfo: any;
    constructor(private apiService: ApiService, private snackBar: MatSnackBar, private router: Router, private deviceService: DeviceDetectorService,) { }

    private getLocationData(): Promise<any> {
        return fetch(configData.IP_INFO)
            .then(res => res.json())
            .catch(error => {
                console.error('Error fetching location data:', error);
                showNotification(this.snackBar, 'Failed to fetch location data', 'error');
                return null;
            });
    }

    trackUserActivity(userdata: any, isLogin: boolean) {
        this.deviceInfo = this.deviceService.getDeviceInfo();
        this.getLocationData().then(response => {
            if (!response) return;

            this.lookupInfo = response;
            const loc = this.lookupInfo['loc'].split(',');

            let activityData = {
                userId: userdata._id,
                createdDate: isLogin ? longDate(new Date()) : localStorage.getItem('login_time') || longDate(new Date()),
                ipAddress: this.lookupInfo['ip'],
                macAddress: "",
                deviceType: "Web",
                deviceName: `${this.deviceInfo?.device || ''} ${this.deviceInfo?.deviceType || ''}`,
                os: this.deviceInfo?.os || 'Unknown',
                osVersion: this.deviceInfo?.osVersion || 'Unknown',
                browser: this.deviceInfo?.browser || 'Unknown',
                browserVersion: this.deviceInfo?.browserVersion || 'Unknown',
                location: `${this.lookupInfo['city']}, ${this.lookupInfo['region']}, ${this.lookupInfo['country']}, ${this.lookupInfo['postal']}`,
                locationLat: loc[0],
                locationLng: loc[1],
                isLogin: isLogin,
                logoutAt: isLogin ? 0 : longDate(new Date()),
                userRole: userdata.superadminRole
            };

            // Send data to API
            this.apiService.httpPostCall(superAdminHttpVersion.V1 + superAdminHttpRoutes.SAVE_LOGIN_HISTORY, activityData)
                .subscribe(response => {
                    if (isLogin) {
                        // Save login data to local storage
                        localStorage.setItem('login_time', activityData.createdDate);
                        localStorage.setItem('user_data', JSON.stringify(userdata));
                    } else {
                        // Clear all client-related local storage data on logout
                        localStorage.clear();
                        this.router.navigate(['/superadmin']);
                    }
                });
        });
    }
}
